(function () {
  'use strict';

  /* @ngdoc object
   * @name vcdrug
   * @description
   *
   */
  angular
    .module('vcdrug', [
      'ngLodash',
      'vcutils.config',
      'vcutils.printhelper'
    ]);

  angular.module('vcdrug')
    .filter('drugname', function () {
      return function (value) {
        if (!value) {
          return '';
        }
        return value.split(' ')[0];
      };
    });
}());
